"use strict";
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
Object.defineProperty(exports, "__esModule", { value: true });
var fontWeights = {
    "bold": 700,
    "semiBold": 600,
    "medium": 500,
    "regular": 400
};
exports.default = fontWeights;
//# sourceMappingURL=fontWeights.js.map